<template>
  <v-main>
    <AppBar dark color="var(--v-primary-base)" />
    <article class="dms-detail">
      <section id="dmsDetailSection01" class="dms-detail-section dms-detail-bg-primary">
        <div class="dms-detail-container">
          <h1 class="dms-detail-title dms-detail-text-light dms-detail-fw-semi-bold">
            하루 한 걸음, 하루 십분<br />
            가장 값진 마음 여행,<br />
            나를 향한 여정을 떠나보세요.
          </h1>
        </div>
      </section>

      <section id="dmsDetailSection02" class="dms-detail-section dms-detail-bg-primary-dark">
        <div class="dms-detail-container">
          <h2 class="dms-detail-title dms-detail-text-light">
            <b class="dms-detail-fw-bold">이용기간</b>&nbsp;
            <span class="dms-detail-text-sky dms-detail-fw-normal">
            연간<b class="dms-detail-title-month dms-detail-fw-bold">48</b>주
          </span>
          </h2>
          <div class="dms-detail-product">
            <!--          <p class="dms-detail-product-title">-->
            <!--            <b class="title-text dms-detail-bg-pink dms-detail-text-light">집중관리 3개월</b>-->
            <!--            <span class="title-icon-plus">더하기</span>-->
            <!--            <b class="title-text">일반관리 9개월</b>-->
            <!--          </p>-->

            <v-img :src="require('@/assets/images/img_diagram_01.png')" />
            <div class="dms-detail-diagram">

            </div>

            <ul class="dms-detail-bullet-list d-flex flex-column align-center px-0 mt-3 pb-5">
              <li class="dms-detail-bullet-list-item dms-detail-text-light">
                집중관리 상담티켓은 <b class="dms-detail-text-sky">선착순</b>으로 배부됩니다.
              </li>
              <li class="dms-detail-bullet-list-item dms-detail-text-light mt-2">
                집중관리 상담티켓은 <b class="dms-detail-text-sky">원하는 때</b>에 시작할 수 있습니다.
              </li>
            </ul>

            <dl class="dms-detail-product-desc">
              <dt class="dms-detail-product-desc-title">
                <b>제공내용</b>
              </dt>
              <dd class="dms-detail-product-desc-content">
                <ol class="dms-detail-product-desc-list">
                  <li class="dms-detail-product-desc-list-item">
                    맞춤형 <b class="dms-detail-fw-extra-bold">마음건강 솔루션</b>
                  </li>
                  <li class="dms-detail-product-desc-list-item">
                    주 1회 <b class="dms-detail-fw-extra-bold">찐한대화</b>(12주)
                  </li>
                  <li class="dms-detail-product-desc-list-item">
                    <b class="dms-detail-fw-extra-bold">도서관</b>(마음관리 컨텐츠) 활용
                  </li>
                </ol>
              </dd>
            </dl>
          </div>
        </div>
      </section>

      <section id="dmsDetailSection03" class="dms-detail-section dms-detail-bg-light">
        <div class="dms-detail-container">
          <h2 class="dms-detail-title">마음 여행의 2가지 핵심!</h2>
          <dl class="dms-detail-checkpoint">
            <dt class="dms-detail-checkpoint-title">
              <b>핵심 01</b>
            </dt>
            <dd class="dms-detail-checkpoint-content">
              <p class="img" style="margin: 18px 0;">
                <img :src="require('@/assets/images/ticket/img-mission-600-x-170.png')" alt="핵심 01 관련 이미지" />
              </p>
              <p class="dms-detail-text-dark dms-detail-fw-bold">
                여행 지원서의 결과에 따라 검증된 <b class="dms-detail-text-primary">미션</b>들 중에서<br />
                나에게 꼭 맞는 <b class="dms-detail-text-primary">맞춤형 여행 일정</b>이 설계돼요!
              </p>
              <p>
                매일매일 십분, 여행 미션 참여를 통해<br />
                나의 마음 나무를 더 건강하게 가꿀 수 있어요.
              </p>
            </dd>
          </dl>
          <dl class="dms-detail-checkpoint">
            <dt class="dms-detail-checkpoint-title">
              <b>핵심 02</b>
            </dt>
            <dd class="dms-detail-checkpoint-content">
              <p class="img" style="margin: 18px 0;">
                <img :src="require('@/assets/images/ticket/img-character-600-x-270.png')" alt="핵심 02 관련 이미지" />
              </p>
              <p class="dms-detail-text-dark dms-detail-fw-bold">
                나만의 여행 <b class="dms-detail-text-primary">가이드</b>와 함께해요!
              </p>
              <p>
                내가 수행한 미션에 대한 전문적인 피드백과 찐한 대화를<br />
                통해 원하는 주제로 이야기할 수 있어요. 정신건강 분야<br />
                전문가가 가이드를 해줘요.
              </p>
            </dd>
          </dl>
        </div>
      </section>

      <section id="dmsDetailSection04" class="dms-detail-section dms-detail-bg-gray-2">
        <div class="dms-detail-container">
          <h2 class="dms-detail-title">여행 가이드 찐한 대화란?</h2>
          <ul class="dms-detail-bullet-list">
            <li class="dms-detail-bullet-list-item">
              정신건강 분야 전문가와 나의 고민에 대해 나누는
              의미 있는 대화예요.
            </li>
            <li class="dms-detail-bullet-list-item">
              내가 선택한 요일과 시간대에 주 1회 진행돼요.
            </li>
            <li class="dms-detail-bullet-list-item">
              예약한 찐한 대화 일정 중 편한 시간에 대화를 나눌 수 있어요.
            </li>
            <li class="dms-detail-bullet-list-item">
              검사 결과를 해석해 주고, 미션에 피드백해 줘요.
            </li>
          </ul>
        </div>
      </section>

      <section id="dmsDetailSection05" class="dms-detail-section dms-detail-bg-primary dms-detail-text-light">
        <div class="dms-detail-container">
          <h2 class="dms-detail-title dms-detail-text-light">
            <span class="dms-detail-text-sky">무엇을</span> 하게되나요?<br />
          </h2>
          <!--        <h3 class="dms-detail-title dms-detail-text-light dms-detail-fw-normal">-->
          <!--          이용기간-->
          <!--          <span class="dms-detail-text-sky">-->
          <!--            <b class="dms-detail-title-month dms-detail-fw-bold">12</b>개월-->
          <!--          </span>-->
          <!--        </h3>-->
          <!--        <dl class="dms-detail-info">-->
          <!--          <dt class="dms-detail-info-title dms-detail-bg-pink dms-detail-text-light">집중관리<br />3개월</dt>-->
          <!--          <dd class="dms-detail-info-content">-->
          <!--            <ul class="dms-detail-bullet-list">-->
          <!--              <li class="dms-detail-bullet-list-item">맞춤 솔루션 제공</li>-->
          <!--              <li class="dms-detail-bullet-list-item">주 1회 찐한대화(휴먼코칭)</li>-->
          <!--              <li class="dms-detail-bullet-list-item">도서관(마음관리 컨텐츠) 활용</li>-->
          <!--            </ul>-->
          <!--          </dd>-->
          <!--        </dl>-->
          <!--        <dl class="dms-detail-info">-->
          <!--          <dt class="dms-detail-info-title">일반관리<br />9개월</dt>-->
          <!--          <dd class="dms-detail-info-content">-->
          <!--            <ul class="dms-detail-bullet-list">-->
          <!--              <li class="dms-detail-bullet-list-item">기본 솔루션 제공</li>-->
          <!--              <li class="dms-detail-bullet-list-item">도서관(마음관리 컨텐츠) 활용</li>-->
          <!--            </ul>-->
          <!--          </dd>-->
          <!--        </dl>-->
          <v-img :src="require('@/assets/images/img_diagram_02.png')" />
          <!--        <p class="dms-detail-fs-sm dms-detail-text-start">*1개월은 4주 기준으로 구성됩니다</p>-->
          <br /><br />
          <h3 class="dms-detail-title dms-detail-fw-normal dms-detail-text-light">
            이런 <b class="dms-detail-fw-normal dms-detail-text-sky">미션 활동</b>들이 있어요!
          </h3>
          <p style="margin-top: -10px">무궁무진한 일정이 준비되어 있답니다.</p>
        </div>
        <swiper
            class="dms-detail-swiper-info"
            :options="{
            loop: true,
            autoplay: {
              delay: 2000
            },
            pagination: false,
            navigation: false,
            centeredSlides: true,
            slidesPerView: 'auto',
            spaceBetween: 23,
            initialSlide: 1
          }"
        >
          <div class="swiper-slide">
            <img :src="require('@/assets/images/ticket/img-service-01@2x.jpg')" />
          </div>
          <div class="swiper-slide">
            <img :src="require('@/assets/images/ticket/img-service-02@2x.jpg')" />
          </div>
          <div class="swiper-slide">
            <img :src="require('@/assets/images/ticket/img-service-03@2x.jpg')" />
          </div>
          <div class="swiper-slide">
            <img :src="require('@/assets/images/ticket/img-service-04@2x.jpg')" />
          </div>
          <div class="swiper-slide">
            <img :src="require('@/assets/images/ticket/img-service-05@2x.jpg')" />
          </div>
        </swiper>
      </section>

      <section id="dmsDetailSection06" class="dms-detail-section dms-detail-bg-primary-light">
        <div class="dms-detail-container">
          <h2 class="dms-detail-title">주제는 무엇인가요?</h2>
          <ul class="dms-detail-topic-list">
            <li class="dms-detail-topic-list-item">자기이해</li>
            <li class="dms-detail-topic-list-item">자기관리/성장</li>
            <li class="dms-detail-topic-list-item">성격/성향</li>
            <li class="dms-detail-topic-list-item">자존감 향상</li>
            <li class="dms-detail-topic-list-item">소진/번아웃</li>
            <li class="dms-detail-topic-list-item">힐링/회복</li>
            <li class="dms-detail-topic-list-item">대인관계</li>
            <li class="dms-detail-topic-list-item">연애/결혼</li>
            <li class="dms-detail-topic-list-item">가족관계</li>
            <li class="dms-detail-topic-list-item">삶의 의미</li>
            <li class="dms-detail-topic-list-item">감정 조절</li>
            <li class="dms-detail-topic-list-item">스트레스</li>
            <li class="dms-detail-topic-list-item">우울</li>
            <li class="dms-detail-topic-list-item">불안</li>
            <li class="dms-detail-topic-list-item">수면</li>
            <li class="dms-detail-topic-list-item">트라우마/상실</li>
          </ul>
          <p class="dms-detail-text-primary dms-detail-fw-bold">주제는 자기성장부터 정신건강 분야까지 다양해요!</p>
          <p>여행 지원서에 작성한 원하는 주제와<br />마음 나무 결과에 따라 여행일정이 구성돼요.</p>
        </div>
      </section>

      <section id="dmsDetailSection07" class="dms-detail-section dms-detail-bg-gray-2">
        <div class="dms-detail-container">
          <h2 class="dms-detail-title">무엇을 얻을 수 있나요?</h2>
          <ul class="dms-detail-bullet-list">
            <li class="dms-detail-bullet-list-item">
              나를 깊이 이해하고 일상에 마음 관리가 스며들 수
              있어요. 심층적인 변화가 시작 돼요.
            </li>
            <li class="dms-detail-bullet-list-item">
              순간순간 자신의 감정과 욕구를 더 명확하게 알고
              조금 더 단단한 내가 될 수 있어요.
            </li>
            <li class="dms-detail-bullet-list-item">
              일상을 조금 더 새롭게 바라보게 돼요.
            </li>
            <li class="dms-detail-bullet-list-item">
              지금보다 더 나 다운 내가 될 수 있어요.
            </li>
            <li class="dms-detail-bullet-list-item">
              내가 가진 심리 자원을 잘 알고, 나의 강점을 잘
              발휘할 수 있어요.
            </li>
          </ul>
        </div>
      </section>

      <section id="dmsDetailSection08" class="dms-detail-section dms-detail-bg-light">
        <div class="dms-detail-container">
          <h2 class="dms-detail-title">이런 분들께 추천드려요!</h2>
          <ul class="dms-detail-comment-list">
            <li class="dms-detail-comment-list-item dms-detail-comment-list-item-01">
              머리가 복잡하고 잠도 잘 안와...
            </li>
            <li class="dms-detail-comment-list-item dms-detail-comment-list-item-02">
              평소에 하던 일인데 요즘은 너무 재미가 없어
            </li>
            <li class="dms-detail-comment-list-item dms-detail-comment-list-item-03">
              내가 지금 잘 하고 있는 걸까?
            </li>
            <li class="dms-detail-comment-list-item dms-detail-comment-list-item-04">
              조금 더 성장하는 내가 되고 싶어!
            </li>
            <li class="dms-detail-comment-list-item dms-detail-comment-list-item-05">
              계속 불안하고 초조해…
            </li>
          </ul>
        </div>
      </section>

      <section id="dmsDetailSection09" class="dms-detail-section dms-detail-bg-gray-1">
        <div class="dms-detail-container">
          <h2 class="dms-detail-title">이용한 분들은 이렇게 이야기해요!</h2>
        </div>
        <swiper
            class="dms-detail-swiper-comment"
            :options="{
            loop: false,
            autoplay: {
              delay: 2000
            },
            pagination: false,
            navigation: false,
            slidesPerView: 'auto',
            spaceBetween: 23
          }"
        >
          <div class="swiper-slide">
            <blockquote class="dms-detail-comment-box">
              처음에 가볍게 시작했는데 생각보다 저에 대해 많은 것을 알게 되고 이해할 수 있게 된 것 같아요. 그리고 짧은 시간이지만 매일 꾸준하게 <b class="dms-detail-text-primary">온전히 나를 위한 시간</b>을 보낸다는 느낌이 들어 뿌듯했어요.
              <span class="dms-detail-comment-box-label">23세 여성, 대학생</span>
            </blockquote>
          </div>
          <div class="swiper-slide">
            <blockquote class="dms-detail-comment-box">
              찐한대화는 미션을 하며 떠오르는 <b class="dms-detail-text-primary">내가 원하는 주제들로만 대화</b>할 수 있고, 부담스럽지 않게 전문가와 일상 속에서의 고민을 나눌 수 있어서 좋았어요! 친구와 카톡하는 느낌으로 <b class="dms-detail-text-primary">새로운 시각</b>을 얻을 수 있게 해주셔서 좋았어요.
              <span class="dms-detail-comment-box-label">29세 남성, 신입사원</span>
            </blockquote>
          </div>
          <div class="swiper-slide">
            <blockquote class="dms-detail-comment-box">
              최근 인간관계에 많이 지치고 나에 대해서도 실망하게 되면서 힘들었는데, 제 상황에 딱 맞는 칼럼들이나 영상들을 보면서 <b class="dms-detail-text-primary">배우는 것도 많고 또 위로받았던 것 같아요.</b>
              <span class="dms-detail-comment-box-label">40세 남성, 자영업</span>
            </blockquote>
          </div>
          <div class="swiper-slide">
            <blockquote class="dms-detail-comment-box">
              나도 모르게 비교하고 스스로 부족한 사람이라는 생각에 괴로웠는데, <b class="dms-detail-text-primary">지금 있는 그대로의 나도 충분히 가치 있고 소중한 사람이라는 것</b>을 알게 됐어요!
              <span class="dms-detail-comment-box-label">35세 여성, 프리랜서</span>
            </blockquote>
          </div>
          <div class="swiper-slide">
            <blockquote class="dms-detail-comment-box">
              요즘 잠도 잘 안 오고 머릿속도 복잡해서 힘들었는데 그 원인이 저의 마음 상태에 달려있다는 사실을 알게됐어요! 조금 더 <b class="dms-detail-text-primary">상황을 객관적으로</b> 바라볼 수 있게 된 것 같아요.
              <span class="dms-detail-comment-box-label">43세 여성, 주부</span>
            </blockquote>
          </div>
        </swiper>
      </section>

      <footer class="dms-detail-footer">
        <div class="dms-detail-container">
          <p class="dms-detail-footer-content">
            세상에서 가장 가치 있는 투자,<br />
            내 마음에 투자하세요
          </p>
          <button type="button" class="dms-detail-btn dms-detail-btn-primary" @click="prevPage()">
            확인
          </button>
        </div>
      </footer>

    </article>
  </v-main>
</template>

<script>
import store from '@/store'
import { swiper } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'

export default {
  components: {
    swiper
  },
  beforeRouteEnter (to, from, next) {
    if (store.state.auth.authUser.clientCd !== 'samsungfire') {
      next('/fo/ticketInfo')
    } else {
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
$dms-detail-light: #ffffff;
$dms-detail-dark: #000000;
$dms-detail-gray: #6e6e6e;
$dms-detail-gray-1: #f0f0f0;
$dms-detail-gray-2: #f7f7f7;
$dms-detail-sky: #6fdbff;
$dms-detail-pink: #ff60f6;
$dms-detail-primary: var(--v-primary-base);
$dms-detail-primary-light: #e9e6ff;
$dms-detail-primary-dark: #623eec;

$dms-detail-colors: (
    "light":     $dms-detail-light,
    "dark":      $dms-detail-dark,
    "gray":      $dms-detail-gray,
    "gray-1":    $dms-detail-gray-1,
    "gray-2":    $dms-detail-gray-2,
    "sky":       $dms-detail-sky,
    "pink":      $dms-detail-pink,
    "primary":       $dms-detail-primary,
    "primary-light": $dms-detail-primary-light,
    "primary-dark":  $dms-detail-primary-dark
) !default;

$dms-detail-font-weight-thin:        100;
$dms-detail-font-weight-extra-light: 200;
$dms-detail-font-weight-light:       300;
$dms-detail-font-weight-normal:      400;
$dms-detail-font-weight-medium:      500;
$dms-detail-font-weight-semi-bold:   600;
$dms-detail-font-weight-bold:        700;
$dms-detail-font-weight-extra-bold:  800;
$dms-detail-font-weight-black:       900;
$dms-detail-font-weights: (
    "thin":        $dms-detail-font-weight-thin,
    "extra-light": $dms-detail-font-weight-extra-light,
    "light":       $dms-detail-font-weight-light,
    "normal":      $dms-detail-font-weight-normal,
    "medium":      $dms-detail-font-weight-medium,
    "semi-bold":   $dms-detail-font-weight-semi-bold,
    "bold":        $dms-detail-font-weight-bold,
    "extra-bold":  $dms-detail-font-weight-extra-bold,
    "black":       $dms-detail-font-weight-black
) !default;
@mixin create-color-set {
  @each $color, $value in $dms-detail-colors {
    &-text-#{$color} {
      color: $value !important;
    }
    &-bg-#{$color} {
      background-color: $value !important;
    }
  }
  @each $weight, $value in $dms-detail-font-weights {
    &-fw-#{$weight} {
      font-weight: $value !important;
    }
  }
}
.dms-detail {
  @include create-color-set();
  text-align: center;
  vertical-align: top;
  line-height: 1.5;
  letter-spacing: -0.7px;
  font-family: 'Pretendard';
  font-size: 14px;
  color: $dms-detail-gray;
  *, *:before, *:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing:    border-box;
    -o-box-sizing:      border-box;
    box-sizing:         border-box;
  }
  p {
    margin: 0 0 8px 0;
  }
  &-text-start {
    text-align: left !important;
  }
  &-fs-sm {
    font-size: 13px !important;
  }
  &-btn {
    display: block;
    padding: 0;
    margin: 0;
    vertical-align: top;
    line-height: 1;
    text-decoration: none;
    font-family: inherit;
    font-size: 16px;
    color: inherit;
    border: 0;
    outline: none;
    background: none;
    &-back {
      width: 60px;
      height: 60px;
      background-size: 9px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('~@/assets/images/ticket/icon-back@3x.png');
    }
    &-primary {
      width: 100%;
      padding: 16px 20px;
      color: #ffffff;
      border-radius: 6px;
      background-color: $dms-detail-primary;
      &:hover, &:focus, &:active {
        background-color: $dms-detail-primary-dark;
      }
    }
  }
  img {
    max-width: 100%;
    vertical-align: top;
  }
  &-header {
    padding: 0;
    margin: 0;
    background-color: $dms-detail-primary;
  }
  &-title {
    padding: 0;
    margin: 0 0 15px 0;
    line-height: 1.36;
    letter-spacing: -1.25px;
    font-weight: $dms-detail-font-weight-bold;
    font-size: 25px;
    color: $dms-detail-dark;
    & + .dms-detail-title {
      margin-top: -20px;
    }
    &-month {
      margin-left: 5px;
      font-size: 28px;
    }
  }
  &-section {
    padding: 35px 0 25px;
    margin: 0;
  }
  &-container {
    max-width: 360px;
    padding: 0 23px;
    margin: 0 auto;
  }
  &-footer {
    padding: 40px 0;
    &-content {
      margin: 0 0 35px 0 !important;
      line-height: 1.36;
      letter-spacing: -1.25px;
      font-weight: $dms-detail-font-weight-bold;
      font-size: 24px;
      color: #333333;
    }
    background-color: $dms-detail-gray-1;
  }
}
#dmsDetailSection01 {
  padding-top: 0;
}
#dmsDetailSection02 {
  background-repeat: no-repeat;
  background-position: center bottom 13px;
  background-size: auto 250px;
  background-image: url('~@/assets/images/ticket/img-coupon-bg-500-x-500.svg');
  //background-image: url('~@/assets/images/ticket/img-coupon-bg-500-x-500.png');
}
#dmsDetailSection03 {
}
#dmsDetailSection04 {
  padding-bottom: 45px;
  color: #fff;
}
#dmsDetailSection05 {
  .dms-detail-bullet-list {
    margin: 0;
    font-size: 13px;
    &-item {
      padding-left: 10px;
      font-weight: $dms-detail-font-weight-normal;
      color: #ffffff;
      &:not(:first-child) {
        margin-top: 5px;
      }
      &:after {
        top: 6px;
        width: 3px;
        height: 3px;
        background-color: #ffffff;
      }
    }
  }
}
#dmsDetailSection06 {
}
#dmsDetailSection07 {
  padding-bottom: 40px;
  .dms-detail-bullet-list {
    padding-top: 27px;
    padding-bottom: 27px;
    margin: 0;
    border-color: $dms-detail-primary;
    background-color: #ffffff;
    &-item {
      line-height: 1.5;
      &:not(:first-child) {
        margin-top: 16px;
      }
    }
  }
}
#dmsDetailSection08 {
  padding-bottom: 40px;
}
#dmsDetailSection09 {
  padding-bottom: 20px;
}
.dms-detail-product {
  &-title {
    .title-text {
      display: inline-block;
      min-width: 125px;
      padding: 9px 0 8px;
      margin: 0;
      letter-spacing: normal;
      line-height: 1;
      font-weight: $dms-detail-font-weight-semi-bold;
      font-size: 16px;
      color: #333333;
      border-radius: 5rem;
      background-color: #ffffff;
    }
    .title-icon-plus {
      display: inline-block;
      position: relative;
      width: 16px;
      height: 16px;
      margin: 0 8px;
      vertical-align: middle;
      text-indent: -9999px;
      font-size: 0;
      &::before, &::after {
        content: "";
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        background-color: #fff;
      }
      &::before {
        width: 16px;
        height: 2px;
        margin: -1px 0 0 -8px;
      }
      &::after {
        width: 2px;
        height: 16px;
        margin: -8px 0 0 -1px;
      }
    }
  }
  &-desc {
    min-height: 132px;
    padding: 13px 0;
    margin: 47px 0;
    color: #333;
    &-title {
      padding: 0;
      margin: 0 0 10px 0;
      text-align: center;
      b {
        display: inline-block;
        min-width: 85px;
        padding: 5px;
        line-height: 1;
        font-weight: $dms-detail-font-weight-bold;
        border-radius: 5rem;
        background-color: #fff;
      }
    }
    &-content {
      padding: 0;
      margin: 0;
    }
    &-list {
      list-style: none;
      display: inline-block;
      padding: 0;
      margin: 0;
      font-weight: $dms-detail-font-weight-medium;
      font-size: 13px;
      counter-reset : numbering;
      &-item {
        position: relative;
        padding: 0 0 0 25px;
        margin: 0;
        text-align: left;
        &::before{
          counter-increment: numbering;
          content: counter(numbering)"";
          display: block;
          position: absolute;
          left: 0;
          top: 3px;
          width: 15px;
          height: 15px;
          padding: 0 1px 0 0;
          line-height: 15px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          border-radius: 50%;
          background-color: #149bb2;
        }
        b {
          font-weight: $dms-detail-font-weight-extra-bold;
        }
      }
    }
  }
}
.dms-detail-checkpoint {
  padding: 0;
  margin: 0;
  & + .dms-detail-checkpoint {
    padding-top: 20px;
    margin-top: 15px;
    border-top: 1px solid #dadada;
  }
  &-title {
    padding: 0;
    margin: 0;
    b {
      display: inline-block;
      min-width: 75px;
      padding: 8px 15px 7px;
      line-height: 1;
      white-space: nowrap;
      letter-spacing: -0.8px;
      font-weight: $dms-detail-font-weight-bold;
      font-size: 16px;
      color: $dms-detail-primary;
      border-radius: 5rem;
      border: 1px solid $dms-detail-primary;
    }
  }
  &-content {
    padding: 0;
    margin: 0;
    word-break: keep-all;
    .img {
      margin: 0;
      img {
        display: block;
        margin: 0 auto;
      }
    }
  }
}
.dms-detail-bullet-list {
  list-style: none;
  padding: 0 25px;
  margin: -5px 0;
  border-radius: 10px;
  border: 1px solid transparent;
  &-item {
    position: relative;
    padding: 0 0 0 12px;
    margin: 0;
    line-height: 1.29;
    text-align: left;
    word-break: keep-all;
    font-weight: $dms-detail-font-weight-medium;
    color: $dms-detail-dark;
    &::after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 7px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: $dms-detail-primary;
    }
    &:not(:first-child) {
      margin-top: 18px;
    }
    &.dms-detail-text-light {
      &::after {
        background-color: white;
      }
    }
  }
}
.dms-detail-info {
  display: table;
  width: 100%;
  padding: 0;
  margin: 10px 0 7px 0;
  border-radius: 10px;
  background-color: #5338cd;
  overflow: hidden;
  > * {
    display: table-cell;
    table-layout: fixed;
    vertical-align: middle;
  }
  &-title {
    width: 90px;
    text-align: center;
    line-height: 1.31;
    font-weight: $dms-detail-font-weight-semi-bold;
    font-size: 16px;
    color: #333333;
    background-color: #ffffff;
  }
  &-content {
    padding: 12px 0;
  }
}
.dms-detail-topic-list {
  list-style: none;
  padding: 0;
  margin: -6px -5px 10px;
  overflow: hidden;
  &-item {
    display: block;
    float: left;
    padding: 12px 16px 11px;
    margin: 6px 5px;
    line-height: 1;
    font-weight: $dms-detail-font-weight-medium;
    color: $dms-detail-primary;
    border-radius: 5rem;
    background-color: $dms-detail-light;
  }
}
.dms-detail-comment-list {
  list-style: none;
  padding: 0;
  margin: 0;
  &-item {
    max-width: 100%;
    height: 70px;
    padding: 16px 0 0 0;
    margin: 0;
    text-align: center;
    letter-spacing: -0.8px;
    font-weight: $dms-detail-font-weight-medium;
    font-size: 16px;
    color: #fff;
    background-position: left center;
    background-repeat: no-repeat;
    background-size: auto 70px;
    clear: both;
    &:after {
      content: "";
      display: block;
      clear: both;
    }
    &:not(:first-child) {
      margin-top: 5px;
    }
    &-01 {
      width: 245px;
      background-image: url('~@/assets/images/ticket/img-rply-01.png');
    }
    &-02 {
      float: right;
      width: 310px;
      background-position: right center;
      background-image: url('~@/assets/images/ticket/img-rply-02.png');
    }
    &-03 {
      width: 226px;
      color: #333333;
      background-image: url('~@/assets/images/ticket/img-rply-03.png');
    }
    &-04 {
      float: right;
      width: 250px;
      background-position: right center;
      background-image: url('~@/assets/images/ticket/img-rply-04.png');
    }
    &-05 {
      width: 195px;
      background-image: url('~@/assets/images/ticket/img-rply-05.png');
    }
  }
}
.dms-detail-comment-box {
  min-height: 235px;
  padding: 20px;
  margin: 0;
  text-align: left;
  word-break: keep-all;
  letter-spacing: -0.8px;
  font-weight: $dms-detail-font-weight-medium;
  font-size: 16px;
  color: $dms-detail-dark;
  border-radius: 10px;
  background-color: #ffffff;
  b {
    font-weight: $dms-detail-font-weight-black;
  }
  &-label {
    display: block;
    margin-top: 16px;
    margin-bottom: -30px;
    line-height: 14px;
    font-weight: $dms-detail-font-weight-medium;
    font-size: 14px;
    color: $dms-detail-gray;
  }
  &::before, &::after {
    content: "";
    display: block;
    width: 100%;
    height: 14px;
    background-repeat: no-repeat;
    background-size: auto 10px;
  }
  &::before {
    margin-bottom: 6px;
    background-position: left center;
    background-image: url('~@/assets/images/ticket/img-quotation-01-22-x-22@3x.png');
  }
  &::after {
    margin-top: 16px;
    background-position: right center;
    background-image: url('~@/assets/images/ticket/img-quotation-02-22-x-22@3x.png');
  }
}
.dms-detail-swiper-info {
  padding: 5px 0 15px 0;
  .swiper-slide, img {
    width: 140px !important;
  }
}
.dms-detail-swiper-comment {
  padding: 0 23px;
  .swiper-slide, img {
    width: 300px !important;
  }
}
</style>
